import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

import { breakpoints } from '@shared/constants';

export const FormWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const ShowPin = styled(Typography.TextBody_14_20)<{ isError: boolean }>(
    ({ isError, theme: { palette } }) => css`
        color: ${palette.tertiary.default};
        cursor: pointer;
        margin-bottom: 56px;
        margin-top: ${isError ? 8 : 16}px;
        text-align: center;

        @media (max-width: ${breakpoints.md}px) {
            margin-bottom: 32px;
        }
    `,
);
